/**
 * Replaces Rebuy's own star rating (fed by Rebuy's cached Yotpo sync, which lags
 * behind) with the live Yotpo star-rating widget on every Rebuy product card.
 * Uses the same widget instance the PLP cards and the PDP use, so the counts match.
 */
(() => {
  const YOTPO_INSTANCE_ID = '499958';
  const BLOCK_SELECTOR = '.rebuy-product-block';
  const WRAPPER_CLASS = 'rebuy-yotpo-rating';
  const APPLIED_CLASS = 'has-yotpo-rating';

  let scanTimer = null;

  function productIdFromBlock(block) {
    const match = block.className.match(/(?:^|\s)product-id-(\d+)(?:\s|$)/);
    return match ? match[1] : null;
  }

  function productUrlFromBlock(block) {
    const link = block.querySelector('.rebuy-product-title-link, .rebuy-product-title a, .rebuy-product-image');
    return link ? link.getAttribute('href') : null;
  }

  function buildWrapper(productId, productUrl) {
    const wrapper = document.createElement('div');
    wrapper.className = WRAPPER_CLASS;
    const widget = document.createElement('div');
    widget.className = 'yotpo-widget-instance';
    widget.setAttribute('data-yotpo-instance-id', YOTPO_INSTANCE_ID);
    widget.setAttribute('data-yotpo-product-id', productId);
    widget.setAttribute('data-yotpo-cart-product-id', '');
    wrapper.appendChild(widget);

    if (productUrl) {
      // The Yotpo star widget scrolls to the page's main reviews widget on click.
      // Inside a recommendation card the click must open the product instead, so
      // stop the event before it reaches the widget and navigate ourselves.
      wrapper.addEventListener(
        'click',
        (event) => {
          event.preventDefault();
          event.stopPropagation();
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.button === 1) {
            window.open(productUrl, '_blank', 'noopener');
          } else {
            window.location.href = productUrl;
          }
        },
        true
      );
    }
    return wrapper;
  }

  function applyToBlock(block) {
    // Only swap cards where Rebuy itself renders a rating; hidden/data-only
    // widgets and products without reviews stay untouched.
    const productId = productIdFromBlock(block);
    const review = block.querySelector('.rebuy-product-review');
    if (!productId || !review) return false;

    const existing = block.querySelector('.' + WRAPPER_CLASS);
    if (existing) {
      const current = existing.querySelector('.yotpo-widget-instance');
      if (current && current.getAttribute('data-yotpo-product-id') === productId) return false;
      existing.remove();
    }

    review.insertAdjacentElement('afterend', buildWrapper(productId, productUrlFromBlock(block)));
    block.classList.add(APPLIED_CLASS);
    return true;
  }

  // The inserted placeholders are initialized by yotpo-dynamic-widgets.js, which
  // watches the DOM for new Yotpo star-rating elements.
  function scan() {
    document.querySelectorAll(BLOCK_SELECTOR).forEach(applyToBlock);
  }

  function scheduleScan() {
    clearTimeout(scanTimer);
    scanTimer = setTimeout(scan, 100);
  }

  ['rebuy.ready', 'rebuy.productsChange'].forEach((name) => {
    document.addEventListener(name, scheduleScan);
  });

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType !== Node.ELEMENT_NODE) continue;
        if (node.matches(BLOCK_SELECTOR) || node.querySelector(BLOCK_SELECTOR)) {
          scheduleScan();
          return;
        }
      }
    }
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleScan);
  } else {
    scheduleScan();
  }

  // Safety net: Rebuy may have rendered before this script ran and before the
  // observer was attached, so re-scan a few times after load.
  window.addEventListener('load', () => {
    [500, 2000, 5000, 10000].forEach((delay) => setTimeout(scan, delay));
  });
})();
